/**
 * REUSABLE COMPONENT - Card
 * Generic card container component
 * Can be used in any React project
 */

import React from 'react';

const Card = ({
  children,
  title,
  subtitle,
  headerAction,
  footer,
  padding = 'default',
  hover = false,
  bordered = true,
  shadow = true,
  className = '',
}) => {
  // Base classes
  const baseClasses = 'bg-white rounded-lg';

  // Padding classes
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    default: 'p-6',
    lg: 'p-8',
  };

  // Border and shadow
  const borderClass = bordered ? 'border border-gray-200' : '';
  const shadowClass = shadow ? 'shadow-sm' : '';
  const hoverClass = hover ? 'hover:shadow-md transition-shadow duration-200' : '';

  // Combine classes
  const cardClasses = `${baseClasses} ${borderClass} ${shadowClass} ${hoverClass} ${className}`;

  const contentPadding = paddingClasses[padding];

  return (
    <div className={cardClasses}>
      {(title || subtitle || headerAction) && (
        <div className={`border-b border-gray-200 ${contentPadding} pb-4`}>
          <div className="flex items-center justify-between">
            <div>
              {title && (
                <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
              )}
              {subtitle && (
                <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
              )}
            </div>
            {headerAction && <div>{headerAction}</div>}
          </div>
        </div>
      )}

      <div className={title || subtitle || headerAction ? contentPadding : contentPadding}>
        {children}
      </div>

      {footer && (
        <div className={`border-t border-gray-200 ${contentPadding} pt-4`}>
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;
